import script from "./userLevelOne.vue?vue&type=script&setup=true&lang=js"
export * from "./userLevelOne.vue?vue&type=script&setup=true&lang=js"

import "./userLevelOne.vue?vue&type=style&index=0&id=658ff2d4&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-658ff2d4"]])

export default __exports__